/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupscomposerplaceholder2Inputs */

const en_groupscomposerplaceholder2 = /** @type {(inputs: Groupscomposerplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message to the group`)
};

const de_groupscomposerplaceholder2 = /** @type {(inputs: Groupscomposerplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht an die Gruppe`)
};

/**
* | output |
* | --- |
* | "Message to the group" |
*
* @param {Groupscomposerplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupscomposerplaceholder2 = /** @type {((inputs?: Groupscomposerplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupscomposerplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupscomposerplaceholder2(inputs)
	return de_groupscomposerplaceholder2(inputs)
});
export { groupscomposerplaceholder2 as "groupsComposerPlaceholder" }